import { useTranslation } from 'react-i18next'
import { parseStringToHtml } from '../../utils/parseStringToHtml'

export const TermsGeneral = () => {
  const { t } = useTranslation()

  return <div>{parseStringToHtml(t('terms.general-terms'))}</div>
}
